<div class="copy-wrap">
  <div class="tips error-tips flex-v-center" *ngIf="result.errors!.length>0">
    <i></i>
    <ul>
      <li *ngFor="let item of result.errors; let i = index">{{item}}</li>
    </ul>
  </div>
  <div class="copy-wrap-content w-full p-8 h-[678px] flex sm:flex-col">
    <div class="copy-wrap-content-left">
      <div id="l_div">
        <div id="line-number-wrap">
          <textarea id="line-number" disabled>{{ lineNumber }}</textarea>
        </div>
        <textarea id="input" nz-input wrap="off" (input)="onInputChange()" (scroll)="onInputScroll()"  [placeholder]="'COPY_AND_PASTE' | translate" [(ngModel)]="textValue" (ngModelChange)="onTextValueChange($event)"></textarea>
      </div>
    </div>
    <div class="copy-wrap-content-right mx:w-[392px] sm:w-full mx:pl-8 sm:px-0 sm:py-4 ">
      <div class="font-bold flex-v-center">
        <svg-icon [iconName]="'new/template.svg'" class="mr10"></svg-icon>
        <span>{{ "TEMPLATE" | translate }}</span>
      </div>
      <div class="my-6">
        {{"COPY_DESC" | translate}}
      </div>
      <div class="copy-wrap-content-right-demo sm:w-full">
        <p>2608630030</p>
        <p class="mt-1.5">F00Y100947 5</p>
        <p class="mt-1.5">F00Y100947;5</p>
        <p class="mt-1.5">2608630030 12</p>
        <p class="mt-1.5">2608630030;10</p>
      </div>
    </div>
  </div>
</div>
